import script from "./FadeAwayMessage.vue?vue&type=script&lang=js"
export * from "./FadeAwayMessage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__